import { render, staticRenderFns } from "./CargaIntro.vue?vue&type=template&id=29269956&"
import script from "./CargaIntro.vue?vue&type=script&lang=js&"
export * from "./CargaIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports